var exports = {
  "i": "xaee3c4fa--804104--wrapper",
  "Q": "xaee3c4fa--804104--item-wrapper",
};

module.exports = exports;
